import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function WhatsAppTestimonialsSection() {
  const {
    lang
  } = useLanguage();
  const testimonials = [{
    text: '"Annysol transformó por completo mi presencia digital. En menos de 2 semanas tenía mi web, mi marca y mis redes listas para atraer clientes. El proceso fue claro, rápido y 100% personalizado."',
    textEn: '"Annysol completely transformed my digital presence. In less than 2 weeks I had my website, my brand, and my networks ready to attract clients. The process was clear, fast, and 100% personalized."',
    initial: 'M',
    name: 'María C.',
    role: 'E-commerce · Miami, FL'
  }, {
    text: '"Lo que más me sorprendió fue que no se trató de una plantilla. Annysol entendió mi negocio, mi mensaje y construyó algo que realmente me representa. Los clientes correctos ahora me encuentran."',
    textEn: '"What surprised me most was that it wasn\'t a template. Annysol understood my business, my message, and built something that truly represents me. The right clients now find me."',
    initial: 'C',
    name: 'Carlos R.',
    role: 'Consultor · Colombia',
    roleEn: 'Consultant · Colombia'
  }, {
    text: '"Tenía presencia pero no sistema. Inkova me ayudó a clarificar mi oferta, rediseñar mi web y activar mi primer funnel de captación. Los resultados llegaron en la primera semana."',
    textEn: '"I had a presence but no system. Inkova helped me clarify my offer, redesign my website, and activate my first capture funnel. The results arrived in the first week."',
    initial: 'L',
    name: 'Laura M.',
    role: 'Coach · Venezuela'
  }];
  return <section id="testimonios" className="py-32 lg:py-40 bg-white" data-id="element-466">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-467">
        <div className="text-center mb-20" data-id="element-468">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center gap-4 mb-8" data-id="element-469">
            <span className="block w-[1px] h-[40px] bg-inkova-primary/30" data-id="element-470" />
            <span className="inline-block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary" data-id="element-471">
              {lang === 'es' ? 'LO QUE DICEN' : 'WHAT THEY SAY'}
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.1
        }} className="text-[32px] sm:text-[4vw] lg:text-[48px] font-serif text-inkova-dark leading-[1.1] tracking-[-0.5px] mb-6 max-w-[800px] mx-auto" data-id="element-472">
            {lang === 'es' ? <>
                Lo que dicen quienes ya dieron el{' '}
                <em className="italic text-inkova-lavender" data-id="element-473">paso</em>
              </> : <>
                What those who already took the{' '}
                <em className="italic text-inkova-lavender" data-id="element-474">step</em> say
              </>}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="text-[16px] lg:text-[18px] text-inkova-dark/70 font-light leading-[1.8]" data-id="element-475">
            {lang === 'es' ? 'Resultados reales de personas reales.' : 'Real results from real people.'}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10 mb-16" data-id="element-476">
          {testimonials.map((testimonio, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: index * 0.15
        }} className="bg-inkova-cream rounded-[24px] p-10 border border-inkova-border hover:-translate-y-2 hover:shadow-[0_24px_64px_rgba(107,63,160,0.08)] transition-all duration-500 flex flex-col" data-id="element-477">
              <div className="text-[#F59E0B] text-[18px] mb-6 tracking-[2px]" data-id="element-478">
                ★★★★★
              </div>
              <p className="text-[16px] text-inkova-dark/80 font-light leading-[1.8] mb-10 flex-1" data-id="element-479">
                {lang === 'es' ? testimonio.text : testimonio.textEn}
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-inkova-border" data-id="element-480">
                <div className="w-[48px] h-[48px] rounded-full bg-inkova-primary/5 flex items-center justify-center text-inkova-primary font-serif text-[20px] shrink-0 border border-inkova-primary/10" data-id="element-481">
                  {testimonio.initial}
                </div>
                <div data-id="element-482">
                  <div className="text-[15px] font-medium text-inkova-dark mb-1" data-id="element-483">
                    {testimonio.name}
                  </div>
                  <div className="text-[13px] text-inkova-dark/50 font-light" data-id="element-484">
                    {lang === 'es' ? testimonio.role : testimonio.roleEn || testimonio.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.4
      }} className="text-center" data-id="element-485">
          <a href="https://g.page/r/inkovacreation/review" target="_blank" rel="noopener noreferrer" className="text-inkova-primary text-[15px] font-medium underline underline-offset-4 hover:text-inkova-lavender transition-colors duration-300" data-id="element-486">
            {lang === 'es' ? 'Ver todos los reviews en Google' : 'See all reviews on Google'}
          </a>
        </motion.div>
      </div>
    </section>;
}